export const SET_OS_TYPE = "SET_OS_TYPE";
export const GET_SERVERS_LIST = "GET_SERVERS_LIST";
export const SET_FETCHING_FLAG = "SET_FETCHING_FLAG";
export const EXISTING_TEMPLATES = "EXISTING_TEMPLATES";
export const ONBOARD_TEMPLATE = "ONBOARD_TEMPLATE";
export const GET_RECENT_JOBS = "GET_RECENT_JOBS";
export const GET_CURRENT_STATUS = "GET_CURRENT_STATUS";
export const GET_CURRENT_ACCESS = "GET_CURRENT_ACCESS";
export const GENERATE_WORKFLOW_ID = "GENERATE_WORKFLOW_ID";
